import React from 'react';
import { useQuery } from '../../utils/helpers';
import PreLoanIndex from '.';
import PreLoanIndexRedesign from './redesign';

// Elige el flujo PLR que se muestra en /preloan:
// - Rediseño (BAN-1322): pages/preloan/redesign.tsx + feature/preloan/v3-redesign.
// - Original de develop: pages/preloan/index.tsx + feature/preloan/v3 (sin cambios).
// Por defecto se muestra el rediseño. REACT_APP_PLR_REDESIGN=false vuelve al original
// para todos; ?flujo=original o ?flujo=nuevo fuerza uno en esa visita (QA, demos, A/B).
export const PLR_REDESIGN_DEFAULT = process.env.REACT_APP_PLR_REDESIGN !== 'false';

export const resolvePlrFlow = (flujo: string | null) => {
  if (flujo === 'nuevo') return true;
  if (flujo === 'original') return false;
  return PLR_REDESIGN_DEFAULT;
};

export default function PreLoanFlowSwitch() {
  const query = useQuery();
  // Se decide una sola vez por carga para que el flujo no cambie a mitad de camino.
  const [redesign] = React.useState(() => resolvePlrFlow(query.get('flujo')));
  return redesign ? <PreLoanIndexRedesign /> : <PreLoanIndex />;
}
